import { PropTypes } from 'prop-types';
import React, {
  Fragment,
  useEffect, useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Divider, Radio, Select, Alert, Popconfirm,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate } from '@Apis/constants';
import EinvoiceEwaybillIntegrationActions from '@Actions/integrations/einvoiceEwaybillActions';
import H3FormInput from '@Uilib/h3FormInput';
import SelectSeller from '@Components/Common/SelectSeller';
import './style.scss';
import Crown from '@Images/crown2.png';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const subTypeMapping = {
  INV: [{ key: 'SUPPLY', label: 'Supply' }, { key: 'EXPORT', label: 'Export' }, { key: 'SKD/CKD', label: 'SKD/CKD' }],
  CNT: [{ key: 'SALES RETURN', label: 'Sales Return' }, { key: 'JOB WORK RETURNS', label: 'Job Work Return' }],
  CHL_ST: [{ key: 'JOB WORK', label: 'Job Work' }, { key: 'SKD/CKD', label: 'SKD/CKD' }],
  CHL_INV: [{ key: 'JOB WORK', label: 'Job Work' }, { key: 'SKD/CKD', label: 'SKD/CKD' }],
  CHL: [{ key: 'JOB WORK', label: 'Job Work' }, { key: 'SKD/CKD', label: 'SKD/CKD' }],
};

const EwaybillForm = ({
  selectedDocType, selectedDocument, genEwaybill, genEwaybillLoading, drawermode, documentDate,
  callback, showDocumentInfo, fetchEwayBill, fetchEwayBillLoading, selectedDocumentId, user, selectedDocumentNumber, entityType,
}) => {
  const [value, setValue] = useState(1);
  const [documentType, setDocumentType] = useState('');
  const [transactionSubType, setTransactionSubType] = useState('');
  const [selectedSeller, setSelectedSeller] = useState('');
  const [selectedSellerDetails, setSelectedSellerDetails] = useState([]);
  const [distance, setDistance] = useState('0');
  const [description, setDescription] = useState('');
  const [modeOfTransport, setModeofTransport] = useState('');
  const [vehicleType, setVehicleType] = useState(1);
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [transporterDocNumber, setTransporterDocNumber] = useState('');
  const [ewaybillNumber, setEwaybillNumber] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (drawermode) {
      setDocumentType(selectedDocType);
    } else if (selectedDocument) {
      setDocumentType(selectedDocument?.documentType);
    }
  }, []);

  const isDataValid = () => {
    if (!transactionSubType || !selectedSeller) {
      return false;
    }
    if (selectedSeller && !selectedSellerDetails.seller_info.gst_number && !modeOfTransport) {
      return false;
    }
    if (modeOfTransport === 'Road' && (!vehicleNumber)) {
      return false;
    }
    if (modeOfTransport && modeOfTransport !== 'Road' && (!transporterDocNumber)) {
      return false;
    }
    if (transporterDocNumber && !transporterDocNumber.match('^[a-zA-Z0-9]{1}[a-zA-Z0-9-/]*$')) return false;
    if (entityType === 'DC' && !description) return false;

    return true;
  };

  const eWaybill = user?.tenant_info?.sales_config?.addons?.e_waybill?.is_active;

  const subTypeOptions = subTypeMapping[documentType]?.map((item) => ({
    label: item?.label,
    value: item?.key,
  }));

  return (
    <div className="ewaybill-form__wrapper" style={drawermode ? { paddingTop: 'unset' } : { paddingTop: '95px' }}>
      <div className="ant-row">
        <div className="ant-col-md-24">
          {showDocumentInfo && (
            <div className="ewaybill-form__header" style={{ lineHeight: '32px' }}>
              <div className="ant-row">
                <div style={{
                  display: 'flex', width: '100%', fontWeight: '500', fontSize: '12.5px',
                }}
                >
                  <div style={{ width: '180px' }}>
                    Document No
                  </div>
                  <div>
                    {selectedDocument?.document_number}
                  </div>
                </div>
                <div style={{
                  display: 'flex', width: '100%', fontWeight: '500', fontSize: '12.5px',
                }}
                >
                  <div style={{ width: '180px' }}>
                    Document Date
                  </div>
                  <div>
                    {selectedDocument?.document_date}
                  </div>
                </div>
                <div style={{
                  display: 'flex', width: '100%', fontWeight: '500', fontSize: '12.5px',
                }}
                >
                  <div style={{ width: '180px' }}>
                    Customer
                  </div>
                  <div>
                    {selectedDocument?.customer_info?.customer_name}
                  </div>
                </div>
              </div>
            </div>
          )}
          <Radio.Group onChange={(e) => { setValue(e.target.value); setFormSubmitted(false); }} value={value} disabled={fetchEwayBillLoading || genEwaybillLoading}>
            <Radio value={1}>Create a new e-Waybill</Radio>
            <Radio value={2}>Associate e-Waybill Number </Radio>
          </Radio.Group>
          {
            value === 1 && (
              <div>
                <div className="ewaybill-form__header">
                  <div className="ant-row">
                    <div className={drawermode ? 'ant-col-md-24 ant-col-xs-24' : 'ant-col-md-12 ant-col-xs-24'}>
                      {selectedSeller && !selectedSellerDetails.seller_info.gst_number && (
                        <Alert
                          style={{ marginTop: '10px' }}
                          message={(
                            <span>
                              <b>Attention: </b>
                              Since the transporter is unregistered, Part B must be filled to complete the e-way bill.
                            </span>
                          )}
                          type="warning"
                          showIcon
                        />
                      )}
                      <Divider orientationMargin="0" orientation="left">Part A</Divider>
                      <div className="ewaybill-form__header-row">
                        <div className="ewaybill-form__input-row__label">
                          Transaction Sub Type
                          <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                        </div>
                        <div className="ewaybill-form__input-row__input ">
                          <PRZSelect
                            value={transactionSubType}
                            disabled={genEwaybillLoading}
                            onChange={(val) => { setTransactionSubType(val); }}
                            options={subTypeOptions}
                            showError={formSubmitted && !transactionSubType}
                            errorName="*Please select transaction sub type"
                            errorClassName="input-error"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={drawermode ? 'ant-col-md-24 ant-col-xs-24' : 'ant-col-md-12 ant-col-xs-24'}>
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        Select Transporter
                        <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <SelectSeller
                          transporter
                          selectedSeller={selectedSeller}
                          onChange={(val) => {
                            setSelectedSeller(val?.seller_id);
                            setSelectedSellerDetails(val);
                          }}
                          containerClass="orgInputContainer"
                          inputClassName="select_row"
                          labelClassName="orgFormLabel"
                          hideTitle
                          disabled={genEwaybillLoading}
                          notRequired
                          mapSellerId
                          showError={formSubmitted && !selectedSeller}
                        />
                      </div>
                    </div>

                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        Distance (in Km)
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <H3FormInput
                          name="Distance (in Km)"
                          type="text"
                          containerClassName="orgInputContainer "
                          inputClassName="orgFormInput  "
                          placeholder="Distance"
                          disabled={genEwaybillLoading}
                          onChange={(e) => setDistance(e.target.value)}
                          value={distance}
                        />
                      </div>

                    </div>

                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        Description
                        {entityType === 'DC' && <span style={{ color: 'red', marginLeft: '3px' }}>*</span>}
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <H3FormInput
                          name="Description"
                          type="text"
                          required
                          containerClassName="orgInputContainer "
                          inputClassName="orgFormInput  "
                          placeholder="Description"
                          disabled={genEwaybillLoading}
                          onChange={(e) => setDescription(e.target.value)}
                          value={description}
                          maxlength={100}
                          showError={formSubmitted && entityType === 'DC' && !description}
                        />
                      </div>

                    </div>
                    <Alert
                      type="info"
                      message={(
                        <div style={{ fontSize: '12px', fontWeight: '500' }}>
                          If you enter 0 as the distance, e-Way Bill system will automatically calculate it based on the dispatch and delivery locations.
                          <div style={{ marginTop: '5px' }}>
                            <a href="https://ewaybillgst.gov.in/Others/P2PDistance.aspx" target="_blank" rel="noreferrer">
                              Calculate Distance ↗
                            </a>
                          </div>
                        </div>
                      )}
                    />
                    <Divider orientationMargin="0" orientation="left">Part B</Divider>
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        Mode Of Transport
                        {selectedSeller && !selectedSellerDetails.seller_info.gst_number && <span style={{ color: 'red', marginLeft: '3px' }}>*</span>}
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <Radio.Group
                          buttonStyle="solid"
                          disabled={genEwaybillLoading}
                          onChange={(e) => {
                            if (e.target.value !== 'Road') {
                              setVehicleNumber('');
                            }
                            setModeofTransport(e.target.value);
                          }}
                          value={modeOfTransport}
                        >
                          <Radio.Button value="Road">
                            {/* <FontAwesomeIcon icon={faTruck} /> */}
                            <H3Text text="Road" />
                          </Radio.Button>
                          <Radio.Button value="Rail">
                            <H3Text text="Rail" />
                          </Radio.Button>
                          <Radio.Button value="Air">
                            <H3Text text="Air" />
                          </Radio.Button>
                          <Radio.Button value="Ship">
                            <H3Text text="Ship" />
                          </Radio.Button>
                        </Radio.Group>
                      </div>
                    </div>
                    {(formSubmitted && selectedSeller && !selectedSellerDetails.seller_info.gst_number && !modeOfTransport) && (
                      <div className="input-error">
                        *Please select mode of transport
                      </div>
                    )}
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        Vehicle Type
                        {modeOfTransport && modeOfTransport === 'Road' && <span style={{ color: 'red', marginLeft: '3px' }}>*</span>}
                      </div>
                      <div className="ewaybill-form__input-row__input" style={{ margin: '5px 0px' }}>
                        <Radio.Group disabled={genEwaybillLoading || modeOfTransport !== 'Road'} onChange={(e) => { setVehicleType(e.target.value); }} value={vehicleType}>
                          <Radio value={1}>Regular</Radio>
                          <Radio value={2}>Over dimensional Cargo </Radio>
                        </Radio.Group>
                      </div>
                    </div>
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        Vehicle Number
                        {modeOfTransport === 'Road' && <span style={{ color: 'red', marginLeft: '3px' }}>*</span>}
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <H3FormInput
                          name="vehicle number"
                          type="text"
                          containerClassName="orgInputContainer "
                          inputClassName="orgFormInput  "
                          onChange={(e) => setVehicleNumber(e.target.value)}
                          value={vehicleNumber}
                          required={modeOfTransport === 'Road'}
                          showError={formSubmitted && (modeOfTransport === 'Road' && !vehicleNumber)}
                          disabled={genEwaybillLoading || modeOfTransport !== 'Road'}
                        />
                      </div>
                    </div>
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        {modeOfTransport === 'Road' && <Fragment>Transporter&apos;s Doc Number</Fragment>}
                        {modeOfTransport === 'Rail' && <Fragment>RR Number</Fragment>}
                        {modeOfTransport === 'Air' && <Fragment>Airway Bill Number</Fragment>}
                        {modeOfTransport === 'Ship' && <Fragment>Bill of Landing Number</Fragment>}
                        {modeOfTransport && modeOfTransport !== 'Road' && <Fragment style={{ color: 'red', marginLeft: '3px' }}>*</Fragment>}
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        {modeOfTransport && (
                          <H3FormInput
                            name="a valid document number"
                            type="text"
                            containerClassName="orgInputContainer "
                            inputClassName="orgFormInput  "
                            onChange={(e) => setTransporterDocNumber(e.target.value)}
                            value={transporterDocNumber}
                            showError={formSubmitted && (transporterDocNumber && !transporterDocNumber.match('^[a-zA-Z0-9]{1}[a-zA-Z0-9-/]*$'))}
                            disabled={genEwaybillLoading}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            )
          }
          {
            value === 2 && (
              <div className="ewaybill-form__header">
                <div className="ant-row">
                  <div className={drawermode ? 'ant-col-md-24 ant-col-xs-24' : 'ant-col-md-12 ant-col-xs-24'}>
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        Ewaybill Number
                        <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <H3FormInput
                          name="Ewaybill Number"
                          type="text"
                          containerClassName="orgInputContainer "
                          inputClassName="orgFormInput  "
                          placeholder="Ewaybill Number"
                          onChange={(e) => setEwaybillNumber(e.target.value)}
                          value={ewaybillNumber}

                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>
      <div className="ewaybill-form__wrapper__footer">

        <H3Button
          text={value === 1 ? 'Generate e-Way Bill' : 'Associate e-Way Bill'}
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          customClass="ewaybill-form__wrapper__footer-submit"
          onClick={() => {
            setFormSubmitted(true);
            if (value === 1) {
              if (isDataValid()) {
                const payload = {
                  irn: selectedDocument?.irn || '',
                  document_id: selectedDocumentId,
                  doc_no: selectedDocumentNumber,
                  tenant_id: selectedDocument?.tenant_id,
                  ship_from: documentType.includes('CHL') ? selectedDocument?.source_address : (documentType === 'INV' ? selectedDocument?.tenant_shipping_address_info : selectedDocument?.shipping_address_info),
                  ship_to: documentType.includes('CHL') ? selectedDocument?.destination_address : (documentType === 'INV' ? selectedDocument?.shipping_address_info : selectedDocument?.tenant_shipping_address_info),
                  is_bill_from_ship_from_same: false,
                  is_bill_to_ship_to_same: false,
                  transporter_id: selectedSeller,
                  transporter_info: selectedSellerDetails?.seller_info,
                  transportation_doc_number: transporterDocNumber,
                  transportation_doc_date: toISTDate(documentDate).format('DD/MM/YYYY'),
                  vehicle_number: vehicleNumber?.replaceAll(' ', ''),
                  vehicle_type: vehicleType === 1 ? 'R' : 'O',
                  transportation_mode: modeOfTransport,
                  distance: Number(distance || 0),
                  sub_type_description: description,
                  doc_type: documentType.includes('CHL') ? 'CHL' : documentType,
                  sub_type: transactionSubType,
                };
                genEwaybill(payload, () => {
                  callback();
                });
              }
            } else {
              fetchEwayBill({
                tenant_id: selectedDocument?.tenant_id,
                document_id: selectedDocumentId,
                doc_type: documentType,
                ewb_no: ewaybillNumber,
              }, () => callback());
            }
          }}
          isLoading={genEwaybillLoading || fetchEwayBillLoading}
          disabled={genEwaybillLoading || fetchEwayBillLoading || !eWaybill}
        />
        {!eWaybill && (
          <Popconfirm
            placement="topRight"
            title="This feature is not accessible within your current plan to use this feature contact us."
            onConfirm={() => window.Intercom('showNewMessage')}
            okText="Contact Us"
            cancelText="Cancel"
          >
            <img
              className="barcode-restrict"
              src={Crown}
              alt="premium"
              style={{
                marginLeft: '8px',
                marginTop: '5px',
              }}
            />
          </Popconfirm>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, InvoiceReducers, EinvoiceEwaybillReducers, CNReducers, DCReducers,
}) => ({
  selectedInvoice: InvoiceReducers.selectedInvoice,
  user: UserReducers.user,
  invoices: InvoiceReducers.invoices,
  genEwaybillLoading: EinvoiceEwaybillReducers.genEwaybillLoading,
  getCNLoading: CNReducers.getCNLoading,
  creditNotes: CNReducers.creditNotes,
  getDCLoading: DCReducers.getDCLoading,
  deliveryChallans: DCReducers.deliveryChallans,
  fetchEwayBillLoading: EinvoiceEwaybillReducers.fetchEwayBillLoading,
});

const mapDispatchToProps = (dispatch) => ({
  genEwaybill: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.genEwaybill(payload, callback)),
  fetchEwayBill: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.fetchEwayBill(payload, callback)),
});

EwaybillForm.propTypes = {
  history: PropTypes.any,
  genEwaybill: PropTypes.func,
  genEwaybillLoading: PropTypes.bool,
  drawermode: PropTypes.bool,
  documentDate: PropTypes.string,
  selectedDocType: PropTypes.string,
  selectedDocument: PropTypes.any,
  fetchEwayBillLoading: PropTypes.bool,
  fetchEwayBill: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EwaybillForm));
